// Better hash function for more diverse color generation
export const generateColorFromString = (str: string): string => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    // Use HSL with softer/flat colors - reduced saturation and adjusted lightness
    const hue = Math.abs(hash) % 360;
    const saturation = 40 + (Math.abs(hash >> 8) % 15); // Reduced from 65-85% to 40-55%
    const lightness = 55 + (Math.abs(hash >> 16) % 10); // Adjusted from 50-65% to 55-65%
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
